import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';
import Icon from './Icon';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <HeaderContainer>
      <div className="container">
        <HeaderContent>
          <Logo>
            <Link to="/">Villa Leïs Auro</Link>
          </Logo>
          <MenuButton onClick={toggleMenu}>
            {isOpen ? <Icon component={FaTimes} /> : <Icon component={FaBars} />}
          </MenuButton>
          <Nav isOpen={isOpen}>
            <NavList>
              <NavItem>
                <NavLink to="/" onClick={() => setIsOpen(false)}>
                  Accueil
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/neighborhood" onClick={() => setIsOpen(false)}>
                  Le Quartier
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/gallery" onClick={() => setIsOpen(false)}>
                  Galerie
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/availability" onClick={() => setIsOpen(false)}>
                  Disponibilités
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/contact" onClick={() => setIsOpen(false)}>
                  Contact
                </NavLink>
              </NavItem>
            </NavList>
          </Nav>
        </HeaderContent>
      </div>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: var(--shadow);
  padding: 2rem 0;
  transition: var(--transition);
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  font-family: var(--font-primary);
  font-size: 2.8rem;
  font-weight: 700;
  
  a {
    color: var(--color-primary);
    
    &:hover {
      color: var(--color-accent);
    }
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 2.4rem;
  color: var(--color-primary);
  
  @media (max-width: 768px) {
    display: block;
  }
`;

interface NavProps {
  isOpen: boolean;
}

const Nav = styled.nav<NavProps>`
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    width: 70%;
    height: 100vh;
    background-color: var(--color-primary);
    padding: 8rem 2rem;
    transform: ${({ isOpen }) => isOpen ? 'translateX(0)' : 'translateX(100%)'};
    transition: var(--transition);
    z-index: 999;
  }
`;

const NavList = styled.ul`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const NavItem = styled.li`
  margin: 0 1.5rem;
  
  @media (max-width: 768px) {
    margin: 1.5rem 0;
  }
`;

const NavLink = styled(Link)`
  font-size: 1.6rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    color: var(--color-accent);
  }
  
  @media (max-width: 768px) {
    color: var(--color-light);
    font-size: 1.8rem;
  }
`;

export default Header;
